import React, { memo } from 'react';
import { useSettings } from '../';
import { FBConnector } from './FBConnector';
export var SettingsConnector = memo(function () {
    var dispatchSettings = useSettings().dispatchSettings;
    return (React.createElement(React.Fragment, null,
        React.createElement(FBConnector, { dispatch: dispatchSettings })));
});
